import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface UpdateRequiredScreenProps {
  visible: boolean;
  onUpdate: () => void;
  onDismiss: () => void;
}

export function UpdateRequiredScreen({ visible, onUpdate, onDismiss }: UpdateRequiredScreenProps) {
  const { t } = useTranslation('common');
  const [loading, setLoading] = useState(false);

  if (!visible) {
    return null;
  }

  const handleUpdate = () => {
    setLoading(true);
    onUpdate();
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        zIndex: 9999,
        top: 0,
        left: 0,
        width: '100vw',
        height: '100dvh',
        backgroundColor: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        px: 4,
      }}
    >
      {loading ? (
        <CircularProgress size={64} sx={{ color: '#0F172A' }} />
      ) : (
        <SystemUpdateAltIcon sx={{ fontSize: 64, color: '#0F172A' }} />
      )}
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          textAlign: 'center',
        }}
      >
        {loading ? t('updateRequiredLoading') : t('updateRequired')}
      </Typography>
      {!loading && (
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            textAlign: 'center',
          }}
        >
          {t('updateRequiredSubtitle')}
        </Typography>
      )}
      <Button
        variant="contained"
        fullWidth
        sx={{ mt: 2, maxWidth: 320 }}
        onClick={handleUpdate}
        disabled={loading}
      >
        {t('updateRequiredButton')}
      </Button>
      <Button
        variant="text"
        fullWidth
        sx={{ maxWidth: 320 }}
        onClick={onDismiss}
        disabled={loading}
      >
        {t('updateRequiredDismiss')}
      </Button>
    </Box>
  );
}
